export const every = [
  {
    text: 'Рабочий стол',
    icon: 'mdi-home',
    to: '/',
    order: 1,
  },
  {
    text: 'Календарь вебинаров',
    icon: 'mdi-calendar',
    to: '/calendar',
    order: 3,
  },
  {
    text: 'Инструкции',
    icon: 'mdi-help-circle-outline',
    to: '/instructions',
    order: 24,
  },
  {
    text: 'Профиль',
    to: '/profile',
    icon: 'mdi-account-cog-outline',
    order: 25,
  },
];

export const application = [
  {
    text: 'Обращения',
    icon: 'mdi-message-outline',
    order: 2,
    children: [
      {
        text: 'Все Обращения',
        icon: 'mdi-message-text-outline',
        to: '/inbox',
      },
      {
        text: 'Группы обращений',
        icon: 'mdi-folder',
        to: '/group-inbox',
      },
    ],
  },
  {
    text: 'Мониторинг',
    icon: 'mdi-monitor-eye',
    to: '/monitoring',
    order: 3,
  },
  {
    text: 'Шаблоны ответов',
    icon: 'mdi-application-settings',
    to: '/templates',
    order: 4,
  },
  {
    text: 'Задачи',
    icon: 'mdi-check-all',
    to: '/tasks',
    order: 5,
  },
  {
    text: 'Корзина',
    icon: 'mdi-trash-can',
    to: '/trash',
    order: 999,
  },
];
